import type { TranslationMessages } from "ra-core";

export const germanMessages: TranslationMessages = {
  ra: {
    action: {
      add_filter: "Filter hinzufügen",
      add: "Neu",
      back: "Zurück",
      bulk_actions:
        "Ein Element ausgewählt |||| %{smart_count} Elemente ausgewählt",
      cancel: "Abbrechen",
      clear_array_input: "Liste löschen",
      clear_input_value: "Eingabe löschen",
      clone: "Klonen",
      confirm: "Bestätigen",
      create: "Erstellen",
      create_item: "%{item} erstellen",
      delete: "Löschen",
      edit: "Bearbeiten",
      export: "Exportieren",
      list: "Liste",
      refresh: "Neu laden",
      remove_filter: "Filter entfernen",
      remove_all_filters: "Alle Filter entfernen",
      remove: "Entfernen",
      save: "Speichern",
      search: "Suchen",
      select_all: "Alles auswählen",
      select_row: "Reihe auswählen",
      show: "Anzeigen",
      sort: "Sortieren",
      undo: "Rückgängig machen",
      unselect: "Abwählen",
      expand: "Erweitern",
      close: "Schließen",
      open_menu: "Menü öffnen",
      close_menu: "Menü schließen",
      update: "Aktualisieren",
      move_up: "Nach oben",
      move_down: "Nach unten",
      open: "Öffnen",
      toggle_theme: "Theme wechseln",
      select_columns: "Spalten auswählen",
      update_application: "App aktualisieren",
      reset: "Zurücksetzen",
      search_columns: "Spalten durchsuchen",
      select_all_button: "Alle auswählen",
    },

    boolean: {
      true: "Ja",
      false: "Nein",
      null: "—",
    },

    page: {
      create: "%{name} erstellen",
      dashboard: "Dashboard",
      edit: "%{name} %{recordRepresentation}",
      error: "Etwas ist schiefgelaufen",
      list: "%{name}",
      loading: "Laden",
      not_found: "Nicht gefunden",
      show: "%{name} %{recordRepresentation}",
      empty: "Noch kein %{name}.",
      invite: "Neu erstellen?",
      access_denied: "Zugriff verweigert",
      authentication_error: "Authentifizierungsfehler",
    },

    input: {
      file: {
        upload_several: "Dateien hier ablegen oder zum Auswählen klicken.",
        upload_single: "Datei hier ablegen oder zum Auswählen klicken.",
      },
      image: {
        upload_several: "Bilder hier ablegen oder zum Auswählen klicken.",
        upload_single: "Bild hier ablegen oder zum Auswählen klicken.",
      },
      references: {
        all_missing: "Die Daten der Referenz können nicht gefunden werden.",
        many_missing:
          "Mindestens eine Referenz scheint nicht mehr verfügbar zu sein.",
        single_missing: "Die Referenz scheint nicht mehr verfügbar zu sein.",
      },
      password: {
        toggle_visible: "Passwort anzeigen",
        toggle_hidden: "Passwort verbergen",
      },
    },

    message: {
      about: "Über",
      are_you_sure: "Sind Sie sicher?",
      auth_error:
        "Bei der Validierung des Authentifizierungstokens ist ein Fehler aufgetreten.",
      bulk_delete_content:
        "Sicher, dass Sie %{name} löschen wollen? |||| Sicher, dass Sie diese %{smart_count} Elemente löschen wollen?",
      bulk_delete_title: "%{name} löschen |||| %{smart_count} %{name} löschen",
      bulk_update_content:
        "Sicher, dass Sie %{name} aktualisieren wollen? |||| Sicher, dass Sie %{smart_count} Elemente aktualisieren wollen?",
      bulk_update_title:
        "%{name} aktualisieren |||| %{smart_count} %{name} aktualisieren",
      clear_array_input: "Sicher, dass Sie die ganze Liste löschen wollen?",
      delete_content: "Sicher, dass Sie dieses Element löschen wollen?",
      delete_title: "%{name} #%{id} löschen",
      details: "Details",
      error:
        "Ein Fehler trat auf, Ihre Anfrage konnte nicht verarbeitet werden.",
      invalid_form:
        "Das Formular ist ungültig. Bitte überprüfen Sie Ihre Eingaben.",
      loading: "Die Seite wird geladen, noch einen Moment.",
      no: "Nein",
      not_found: "Sie haben eine falsche URL aufgerufen oder eingegeben.",
      yes: "Ja",
      unsaved_changes:
        "Einige Änderungen wurden nicht gespeichert. Sicher, dass Sie diese verwerfen wollen?",
      access_denied: "Zugriff verweigert",
      authentication_error: "Authentifizierungsfehler",
      select_all_limit_reached:
        "Es können nicht alle Elemente ausgewählt werden, da das Limit (%{max}) erreicht wurde.",
      placeholder_data_warning:
        "Die angezeigten Daten sind möglicherweise unvollständig (Platzhalterdaten).",
    },

    navigation: {
      no_results: "Keine Ergebnisse gefunden.",
      no_filtered_results:
        "Keine Ergebnisse. Versuchen Sie, die Filter zu ändern.",
      clear_filters: "Filter zurücksetzen",

      no_more_results: "Es gibt keine Seite %{page}. Versuche eine vorherige.",
      page_out_of_boundaries: "Es gibt keine Seite %{page}.",
      page_out_from_end: "Es gibt keine Seite mehr nach dieser.",
      page_out_from_begin: "Es gibt keine Seite vor Seite 1.",
      page_range_info: "%{offsetBegin}-%{offsetEnd} von %{total}",
      partial_page_range_info:
        "%{offsetBegin}-%{offsetEnd} von mehr als %{offsetEnd}",
      page_rows_per_page: "Zeilen pro Seite:",
      current_page: "Seite %{page}",
      page: "Gehe zu Seite %{page}",
      first: "Gehe zur ersten Seite",
      last: "Gehe zur letzten Seite",
      next: "Gehe zur nächsten Seite",
      previous: "Gehe zur vorherigen Seite",
      skip_nav: "Zum Inhalt springen",
    },

    sort: {
      sort_by: "Nach %{field} %{order} sortieren",
      ASC: "aufsteigend",
      DESC: "absteigend",
    },

    auth: {
      auth_check_error: "Bitte anmelden, um fortzufahren",
      user_menu: "Profil",
      username: "Benutzername",
      password: "Passwort",
      email: "E-Mail",
      sign_in: "Anmelden",
      sign_in_error: "Anmeldung fehlgeschlagen, bitte erneut versuchen.",
      logout: "Abmelden",
    },

    notification: {
      updated: "Element aktualisiert |||| %{smart_count} Elemente aktualisiert",
      created: "Element erstellt",
      deleted: "Element gelöscht |||| %{smart_count} Elemente gelöscht",
      bad_item: "Fehlerhaftes Element",
      item_doesnt_exist: "Element existiert nicht",
      http_error: "Kommunikation mit dem Server fehlgeschlagen",
      data_provider_error: "DataProvider-Fehler. Mehr Details in der Konsole.",
      i18n_error:
        "Die Übersetzungen für die ausgewählte Sprache können nicht geladen werden",
      canceled: "Aktion abgebrochen",
      logged_out: "Ihre Sitzung ist abgelaufen, bitte erneut anmelden.",
      not_authorized:
        "Sie sind nicht berechtigt, auf diese Ressource zuzugreifen.",
      application_update_available: "Ein Update der Anwendung ist verfügbar",
      offline: "Keine Verbindung. Bitte prüfen Sie Ihre Internetverbindung.",
    },

    validation: {
      required: "Erforderlich",
      minLength: "Muss mindestens %{min} Zeichen betragen",
      maxLength: "Darf %{max} Zeichen oder weniger betragen",
      minValue: "Muss mindestens %{min} betragen",
      maxValue: "Darf %{max} oder weniger betragen",
      number: "Muss eine Zahl sein",
      email: "Muss eine gültige E-Mail sein",
      oneOf: "Muss eine der folgenden Optionen sein: %{options}",
      regex: "Muss einem bestimmten Format entsprechen (RegExp): %{pattern}",
      unique: "Dieser Wert wird bereits verwendet",
    },

    saved_queries: {
      label: "Gespeicherte Anfragen",
      query_name: "Name der Anfrage",
      new_label: "Aktuelle Anfrage speichern…",
      new_dialog_title: "Aktuelle Anfrage speichern als",
      remove_label: "Gespeicherte Anfrage löschen",
      remove_label_with_name: 'Anfrage "%{name}" löschen',
      remove_dialog_title: "Gespeicherte Anfrage löschen?",
      remove_message:
        "Sicher, dass Sie diese Anfrage aus der Liste der gespeicherten löschen wollen?",
      help: "Liste filtern und diese Anfrage für später speichern",
    },

    configurable: {
      customize: "Anpassen",
      configureMode: "Diese Seite anpassen",
      inspector: {
        title: "Inspektor",
        content:
          "Bewegen Sie den Mauszeiger über UI-Elemente, um sie zu konfigurieren",
        reset: "Einstellungen zurücksetzen",
        hideAll: "Alles verbergen",
        showAll: "Alles anzeigen",
      },
      Datagrid: {
        title: "Datagrid",
        unlabeled: "Unbekannte Spalte #%{column}",
      },
      SimpleForm: {
        title: "Formular",
        unlabeled: "Unbenanntes Feld #%{input}",
      },
      SimpleList: {
        title: "Liste",
        primaryText: "Primärtext",
        secondaryText: "Sekundärtext",
        tertiaryText: "Tertiärtext",
      },
    },
  },
};

export default germanMessages;
